
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@environment/environment';
import { GetEnvVarService } from "../../service/get-env-var.service";

@Injectable()
export class LoginService {
  private baseUrl: string;
  login: any;
  constructor(private http: HttpClient, private getEnvVarService: GetEnvVarService) {

    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }
  // Method to get the invoice grid
  GetLogin(Login: any): Observable<any> {
    debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/Logink`, JSON.stringify(Login), options).pipe(
      map(response => response as any));
  }

  LockUser(Login:any): Observable<any> {
    debugger;
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers };
    return this.http.post(this.baseUrl + `/api/LockUser`,JSON.stringify(Login),options).pipe(
      map(response => response as any));

    }

}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return observableThrowError(errorMsg);
}

